import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import {useEffect, useRef} from "react";

const NetworkFitBounds = ({markers}) => {
    const map = useMap();
    const coreLib = useMapsLibrary("core");

    const alreadyFit = useRef(false);

    useEffect(() => {
        if (!map || !markers?.length || alreadyFit.current) return;

        const bounds = new coreLib.LatLngBounds();
        markers.forEach((marker) => bounds.extend({lat: marker.lat, lng: marker.lng}));

        if (markers.length === 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
        } else {
            map.fitBounds(bounds, {top: 50, bottom: 50, left: 50, right: 50});
        }

        alreadyFit.current = true;
    }, [map, markers]);

    return null;
};

export default NetworkFitBounds;
